<template>
  <div>
    <vx-card
      ref="filterCard"
      title="Filters"
      class="user-list-filters mb-8"
      actionButtons
    >
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">From </label>

          <flat-pickr
            placeholder="Select Date"
            :config="configFromdateTimePicker"
            v-model="fromDate"
            @on-change="onFromChange"
            style="margin-left: 16px;"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">To </label>
          <flat-pickr
            :config="configTodateTimePicker"
            v-model="toDate"
            placeholder="To Date"
          />
        </div>

        <div
          class="vx-col md:w-1/4 sm:w-1/2 w-full"
          v-if="branchesList"
          style="display: -webkit-inline-box"
        >
          <label class="text-sm opacity-75" style="padding-right: 1rem"
            >Branches</label
          >
          <vs-select
            class="branches"
            placeholder="Branch"
            v-model="branchIds"
            max-selected="5"
            multiple
            autocomplete
            @input="fromBranchSelected"
          >
            <vs-select-item
              v-for="(item, index) in branchesList"
              :key="index"
              :value="item.branchId"
              :text="item.branchName"
            />
          </vs-select>
        </div>
        <div
          class="vx-col md:w-1/4 sm:w-1/2 w-full"
          v-if="consignmentStatus"
          style="display: -webkit-inline-box;padding:0px"
        >
          <label
            class="text-sm opacity-75"
            style="padding-right: 1rem;padding-left: 1rem;"
          >
            Status</label
          >
          <vs-select
            class="consignmentStatus"
            placeholder="Booking Status"
            v-model="consignmentStatusId"
            autocomplete
          >
            <vs-select-item
              v-for="(item, index) in consignmentStatus"
              :key="index"
              :value="item.statusValue"
              :text="item.statusName"
            />
          </vs-select>
        </div>
      </div>
      <br />
      <div class="vx-row">
        <div
          class="vx-col md:w-1/4 sm:w-1/2 w-full"
          v-if="consignmentPaymentTypes"
          style="display: -webkit-inline-box;"
        >
          <label class="text-sm opacity-75" style="padding-right: 1.4rem;"
            >Type</label
          >
          <vs-select
            class="consignmentStatus"
            placeholder="Booking Type"
            v-model="paymentStatusId"
            autocomplete
          >
            <vs-select-item
              v-for="(item, index) in consignmentPaymentTypes"
              :key="index"
              :value="item.value"
              :text="item.label"
            />
          </vs-select>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full"></div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full"></div>
        <div
          class="vx-col md:w-1/4 sm:w-1/2 w-full"
          style="float: left;display: inherit;"
        >
          <vs-button @click="getConsignmentsData" class="ml-auto"
            >Show</vs-button
          >
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6" v-if="consignmentsData.length > 0">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="
                p-4
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              "
            >
              <span class="mr-2"
                >{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{
                  consignmentsData.length - currentPage * paginationPageSize > 0
                    ? currentPage * paginationPageSize
                    : consignmentsData.length
                }}
                of {{ consignmentsData.length }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="
            sm:mr-4
            mr-0
            sm:w-auto
            w-full
            sm:order-normal
            order-3
            sm:mt-0
            mt-4
          "
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

        <!-- ACTION - DROPDOWN -->
        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="
              p-3
              shadow-drop
              rounded-lg
              d-theme-dark-light-bg
              cursor-pointer
              flex
              items-end
              justify-center
              text-lg
              font-medium
              w-32
            "
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item>
              <span class="flex items-center">
                <feather-icon
                  icon="SaveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>
                  <download-excel
                    :data="getCSVData"
                    worksheet="My Worksheet"
                    type="xls"
                    :header="json_fields"
                    :name="csvFileName"
                  >
                    CSV
                  </download-excel>
                </span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="consignmentsData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
      >
      </ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
    <div
      class="vx-card p-6"
      v-else-if="consignmentsData.length === 0 && this.sentRequest"
    >
      <b>No Consignments Found</b>
    </div>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    flatPickr,
    "ag-grid-vue": AgGridVue
  },
  data() {
    return {
      consignmentPaymentTypes: [
        {
          value: 1,
          label: "Paid"
        },
        {
          value: 2,
          label: "To-Pay"
        },
        {
          value: 3,
          label: "TBB"
        }
      ],
      json_fields: {
        "LR No": "consignmentLrNo",
        From: "consignmentFromBranchName",
        To: "consignmentToBranchName",
        Consignor: "consignmentConsignorData",
        Consignee: "consignmentConsigneeData",
        "Freight No": "consignmentFreightNo",
        "Freight Charge": "consignmentGrandTotalCharge",
        "Collection Agent": "collectionAgentName",
        "Total Packages": "consignmentPackagesTotalCnt",
        "Booked Date": {
          field: "consignmentBookedDate",
          callback: value => {
            return value;
          }
        }
      },

      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      csvData: {
        data: []
      },
      csvFileName: `Consignments-${Math.round(+new Date() / 100)}`,
      sentRequest: false,
      consignmentsData: [],
      fromDate: null,
      toDate: null,
      branchIds: [],
      consignmentStatusId: 0,
      paymentStatusId: 0,
      minDate: null,
      branchesList: [{ branchName: "All", branchId: 999 }],
      consignmentStatus: [],

      configFromdateTimePicker: {
        altFormat: "M j, Y",
        dateFormat: "d-m-Y"
      },

      configTodateTimePicker: {
        minDate: null,
        dateFormat: "d-m-Y"
      },
      searchQuery: "",
      // pdfUrl: "http://localhost:8081/transport-System/PDF/views/new/",
      pdfUrl: "https://newpdf.srisainadhtransport.in/2024/",
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: "From",
          field: "consignmentFromBranchName",
          filter: true,
          width: 210
        },
        {
          headerName: "To",
          field: "consignmentToBranchName",
          filter: true,
          width: 225
        },
        {
          headerName: "LR  No",
          field: "consignmentLrNo",
          filter: true,
          width: 200
        },
        {
          headerName: "Freight No",
          field: "consignmentFreightNo",
          filter: true,
          width: 150
        },
        {
          headerName: "CG",
          field: "collectionAgentName",
          filter: true,
          width: 150
        },
        {
          headerName: "Noof Packages",
          field: "consignmentPackagesTotalCnt",
          filter: true,
          width: 150
        },
        {
          headerName: "Consignor",
          field: "consignmentConsignorData",
          filter: true,
          width: 150
        },
        {
          headerName: "Consignee",
          field: "consignmentConsigneeData",
          filter: true,
          width: 150
        },
        {
          headerName: "Freight",
          field: "consignmentGrandTotalCharge",
          filter: true,
          width: 150
        },
        {
          headerName: "Booked Date",
          field: "consignmentBookedDate",
          filter: true,
          width: 150
        }
      ]
    };
  },
  methods: {
    exportcsv() {
      this.gridApi.exportDataAsCsv();
    },
    showpdf() {
      const url =
        this.pdfUrl +
        "ddspdf.php?branch=" +
        this.branchIds.join(",") +
        "&fromDate=" +
        this.fromDate +
        "&toDate=" +
        this.toDate;
      // alert(url);
      window.open(url, "_blank");
      return false;
      // alert("Show PDF");
    },
    onFromChange(selectedDates, dateStr, _instance) {
      this.$set(this.configTodateTimePicker, "minDate", dateStr);
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    getConsignmentsData() {
      this.sentRequest = false;
      this.$http
        .post("portage/consignmentreport", {
          fromDate: this.fromDate,
          toDate: this.toDate,
          branchIds: this.branchIds,
          consignmentStatusId: this.consignmentStatusId,
          paymentStatusId: this.paymentStatusId
        })
        .then(response => {
          const csv = [];
          this.consignmentsData = response.data.data;
          this.consignmentsData.forEach(element => {
            const record = {
              consignmentLrNo: element.consignmentLrNo,
              consignmentFromBranchName: element.consignmentFromBranchName,
              consignmentToBranchName: element.consignmentToBranchName,
              consignmentConsignorData: element.consignmentConsignorData,
              consignmentConsigneeData: element.consignmentConsigneeData,
              consignmentFreightNo: element.consignmentFreightNo,
              consignmentGrandTotalCharge: element.consignmentGrandTotalCharge,
              collectionAgentName: element.collectionAgentName,
              consignmentPackagesTotalCnt: element.consignmentPackagesTotalCnt,
              consignmentBookedDate: element.consignmentBookedDate
            };
            csv.push(record);
          });
          const sampleData = JSON.parse(JSON.stringify(csv));
          // console.log(this.csvData, sampleData);
          this.csvData.data = sampleData;
          // this.csvData.subscribe(data => console.log(data));
          console.log(this.csvData.data);
          this.sentRequest = true;
        });
    },

    fromBranchSelected() {
      // console.log(this.branchIds);
      if (this.branchIds.includes(999)) {
        this.branchIds = [];
        setTimeout(() => {
          this.branchIds.unshift(999);
        }, 10);
      } else {
        //nothing
      }
    }

    // fromStatusSelected() {
    //   if (this.consignmentStatusIds.includes(999)) {
    //     this.branchIds = [];
    //     setTimeout(() => {
    //       this.consignmentStatusIds.unshift(999);
    //     }, 10);
    //   } else {
    //     //nothing
    //   }
    // }
  },
  computed: {
    getCSVData() {
      const sampleData = JSON.parse(JSON.stringify(this.csvData.data));
      return [...sampleData];
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        if (this.gridApi) this.gridApi.paginationGoToPage(val - 1);
      }
    }
  },
  beforeMount() {
    this.$http.get("common/branches").then(response => {
      this.branchesList.push(...response.data.data);
    });
    this.$http.get("portage/getconsignmentstatus").then(response => {
      this.consignmentStatus.push(...response.data.data);
    });
  }
};
</script>
